import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import type { BoxT } from '@mentimeter/ragnar-ui/box';

export const Limit = (props: BoxT) => (
  <Box maxWidth="40em" width="100%" {...props} />
);
